function ledgerDateKey(value) {
  const text = String(value || '').trim();
  const slash = text.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/);
  if (slash) {
    let year = parseInt(slash[3], 10);
    if (year < 100) year += 2000;
    const month = String(parseInt(slash[1], 10)).padStart(2, '0');
    const day = String(parseInt(slash[2], 10)).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  const iso = text.match(/^(\d{4}-\d{2}-\d{2})/);
  return iso ? iso[1] : '';
}

function isUnmatchedTaggedLedgerRow(transaction, taggedIds, fromDate, toDate) {
  if (!transaction || !fromDate || !toDate) return false;
  const id = Number(transaction.Id);
  const tagged = (taggedIds || []).some((tid) => Number(tid) === id && id);
  if (!tagged) return false;
  if (Number(transaction.Matched) === 1) return false;
  const key = ledgerDateKey(transaction.Date);
  if (!key) return false;
  const start = fromDate <= toDate ? fromDate : toDate;
  const end = fromDate <= toDate ? toDate : fromDate;
  return key >= start && key <= end;
}

module.exports = {
  ledgerDateKey,
  isUnmatchedTaggedLedgerRow,
};
